import gsap from 'gsap';
import Swiper from "swiper";

export default () => {
  projectsFwSliders();
  setTimeout(function(){
    zoomImages();
  }, 3000);
  
  function projectsFwSliders() {
    let sliders = document.querySelectorAll('.full-width-slider');
    if (sliders.length) {
      sliders.forEach(function(slider) {

        let mainSlider = new Swiper(slider, {
          wrapperClass: "full-width-slider__wrapper",
          slideClass: "full-width-slider__slide",
          slidesPerView: '1',
          touchStartPreventDefault: false,
          loop: true,
          speed: 600,
          lazy: {
            loadPrevNext: true,
            elementClass: 'full-width-slider__img'
          },
        });
      });
    }
  }

  function zoomImages() {
    console.log("zoom insight");
    let pageWrapper = document.querySelector('main');
    let fsImages;
    let cursor = document.querySelector('.cursor');

    let images = document.querySelectorAll('.project-info img');
    console.log(images);
    if (images.length && pageWrapper) {

      images.forEach(function(image, index) {
        let newImg = new Image();

        if (typeof image.dataset.srcZoom !== 'undefined' && image.dataset.srcZoom) {
          newImg.src = image.dataset.srcZoom;
        } else if (!!newImg.src) {
          newImg.src = image.src;
        } else {
          newImg.src = image.dataset.src;
        }
        
        newImg.classList.add('project-info__fsimg');

        pageWrapper.appendChild(newImg);

        image.addEventListener('click', (e) => {
          fsImages[index].classList.add('project-info__fsimg--visible');
          cursor.classList.add('cursor--close');
        });
      });

      fsImages = document.querySelectorAll('.project-info__fsimg');

      fsImages.forEach(function(img) {
        img.addEventListener('click', (e) => {
          img.classList.remove('project-info__fsimg--visible');
          cursor.classList.remove('cursor--close');
        });
      });
    }
  }
};
